import { render, staticRenderFns } from "./PaymentBase.vue?vue&type=template&id=718ea7ba&"
import script from "./PaymentBase.vue?vue&type=script&lang=js&"
export * from "./PaymentBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports